import intl from "react-intl-universal";
import { TbLink, TbUsers } from "react-icons/tb";
import { ShortcutCard } from "../../../../../Components/Atoms/ShortcutCard";
import { BAAS_ONBOARD_PATH } from "../../constants";

/**
 * Entidades list shortcuts. Public onboard for a new person is Criar → Pessoa →
 * Link público. Instance-wide blank KYC links: shortcut → /baas/onboard when
 * kyc.invite_link is on. Entity-bound revalidation stays on the row kebab
 * (person only) and on entity detail.
 */
export const BaasEntidadesQuickActions = ({
  createEntityEnabled = false,
  onboardLinksEnabled = false,
  onCreateEntityClick,
}) => {
  if (!createEntityEnabled && !onboardLinksEnabled) {
    return null;
  }

  return (
    <section className="min-w-0 w-full space-y-3">
      <p className="dashboard-section-label mb-3">
        {intl.get("baas.entidades.quickActionsSection")}
      </p>
      <div className="shortcut-scroll-row">
        {createEntityEnabled ? (
          <ShortcutCard
            icon={TbUsers}
            label={intl.get("baas.entidades.quickActions.createEntity")}
            onClick={() => onCreateEntityClick?.()}
          />
        ) : null}
        {onboardLinksEnabled ? (
          <ShortcutCard
            icon={TbLink}
            label={intl.get("baas.entidades.quickActions.onboardLinks")}
            to={BAAS_ONBOARD_PATH}
            title={intl.get("baas.entidades.quickActions.onboardListHint")}
          />
        ) : null}
      </div>
    </section>
  );
};
